import { EXPEDIENTE } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null, 
    ventana_filtros: false, 
    filtros: null
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case EXPEDIENTE.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case EXPEDIENTE.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        case EXPEDIENTE.FILTROS:
            return {
                ...state,
                ventana_filtros: payload
            };

        default:
            return state;
    }
}